  {#if src && type !== 'local'}
  <div class="video-padding" class:no-pointer-events={hoverInfo}>
    <iframe
      src={src()}
      frameborder="0"
      allowfullscreen
      title="video"
    />
  </div>
{:else if src && type === 'local'}
  <!-- svelte-ignore a11y-media-has-caption -->
  <div class="video-padding">
    <video autoplay={autoplay} loop={loop} muted={autoplay} name="media">
      <source src={fields?.videoURL} type="video/mp4">
    </video>
  </div>
{:else}
  <p>Please set a valid video URL.</p>
{/if}

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['plugin__video']
</script>

<script>
  export let fields = {}

  let type = ''
  const hoverInfo = fields.hoverInfo || false
  const rel = Number(fields.showRelatedVideos)
  const controls = Number(fields.showControls)
  const info = Number(fields.showInfo)
  const autoplay = Number(fields.autoPlay)
  const loop = Number(fields.loop)

  function src () {
    const videoURL = fields.videoURL
    if (!videoURL) {
      return
    }

    let src = ''
    type = ''

    if (videoURL.toLowerCase().indexOf('youtube.') >= 0 || videoURL.toLowerCase().indexOf('youtu.be') >= 0) {
      type = 'youtube'
    } else if (videoURL.toLowerCase().indexOf('vimeo.') >= 0) {
      type = 'vimeo'
    }

    if (!type) {
      type = 'local'
      return src
    }

    switch (type) {
      case 'youtube': {
        let videoId = ''

        if (videoURL.indexOf('?') >= 0) {
          videoId = videoURL.split('?')
            .pop()
            .replace(/^\?/, '')
            .split('&')
            .map(seg => seg.split('='))
            .reduce((acc, cur) => {
              if (cur[0] === 'v') {
                acc = cur[1]
              }
              return acc
            }, '')
        } else {
          videoId = videoURL.split('/').pop()
        }

        src = `https://www.youtube-nocookie.com/embed/${videoId}?` + [
          `rel=${rel}`,
          `controls=${controls}`,
          `showinfo=${info}`,
          `autoplay=${autoplay}`,
          `${autoplay ? 'mute=1' : ''}`,
          `loop=${loop}`,
          `${loop ? 'playlist=' + videoId : ''}`,
        ].join('&')
      } break
      case 'vimeo': {
        const videoId = videoURL.split('/').pop()
        const autoplay = Number(fields.autoPlay)
        const loop = Number(fields.loop)

        src = `https://player.vimeo.com/video/${videoId}?` + [
          `autoplay=${autoplay}`,
          `loop=${loop}`,
        ].join('&')
      } break
    }

    return src
  }

</script>

<style>
  :global(.plugin__video) {
    position: relative;
  }

  .video-padding {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
  }

  iframe, video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-width: 0;
    border: none;
  }
  .no-pointer-events {
    pointer-events: none;
  }

</style>
